import * as React from "react";
import { DatePicker, Select, Card, LocaleProvider } from "antd";
import en_GB from "antd/lib/locale-provider/en_GB";
import OrdersSumQuery from "src/queries/OrdersSumQuery/OrdersSumQuery";
import moment from "moment";
import "moment/locale/en-gb";
import { SumSteps } from "src/__generated__/types";
import SumResultCard from "./SumResultCard";

const { RangePicker } = DatePicker;
const Option = Select.Option;
export interface SumOrderedProps {}

export interface SumOrderedState {
  startTimeStamp: number | null;
  endTimeStamp: number | null;
  timeStep: SumSteps;
}

export const sumStepDesc = {
  [SumSteps.MIN_15]: "15min",
  [SumSteps.MIN_30]: "30min",
  [SumSteps.HR_1]: "1h",
  [SumSteps.HR_6]: "6h",
  [SumSteps.HR_12]: "12h",
  [SumSteps.DAY]: "1d",
  [SumSteps.ALL]: "Sum"
};

export default class SumOrdered extends React.Component<
  SumOrderedProps,
  SumOrderedState
> {
  timeFormat = "DD.MM.YYYY HH:mm";
  constructor(props: SumOrderedProps) {
    super(props);
    this.state = {
      startTimeStamp: null,
      endTimeStamp: null,
      timeStep: SumSteps.MIN_15
    };
    this.handleTimeSelect = this.handleTimeSelect.bind(this);
    this.handleStepChange = this.handleStepChange.bind(this);
  }
  handleStepChange(value: SumSteps) {
    this.setState({ timeStep: value });
  }
  handleTimeSelect(selectedTime: moment.Moment[]) {
    const [start, end] = selectedTime;
    this.setState({
      startTimeStamp: start.valueOf(),
      endTimeStamp: end.valueOf()
    });
  }
  public render() {
    return (
      <>
        <Card title="Orders over time" style={{ marginTop: 30 }}>
          <label style={{ paddingRight: 5 }}>Show orders between</label>
          <LocaleProvider locale={en_GB}>
            <RangePicker
              showTime={{ format: "HH:mm" }}
              format={this.timeFormat}
              placeholder={["Start Time", "End Time"]}
              //onChange={onChange}
              onOk={this.handleTimeSelect as () => void}
            />
          </LocaleProvider>
          <label style={{ padding: 5 }}>group by</label>
          <Select
            style={{ width: 100 }}
            onChange={this.handleStepChange}
            value={this.state.timeStep}
          >
            {Object.keys(sumStepDesc).map(step => (
              <Option key={step} value={step}>
                {sumStepDesc[step]}
              </Option>
            ))}
          </Select>
        </Card>

        {this.state.startTimeStamp && this.state.endTimeStamp && (
          <OrdersSumQuery
            startTimeStamp={this.state.startTimeStamp}
            endTimeStamp={this.state.endTimeStamp}
            timeStep={this.state.timeStep}
          >
            {result => (
              <>
                <div>
                  {result.loading ? (
                    <Card style={{ marginTop: 30 }} loading={true}>
                      Loading...
                    </Card>
                  ) : (
                    result.data &&
                    result.data.ordersSumItems.result &&
                    result.data.ordersSumItems.result.map(
                      i =>
                        i && (
                          <SumResultCard
                            item={i}
                            timeFormat={this.timeFormat}
                            startTimeStamp={this.state.startTimeStamp}
                            endTimeStamp={this.state.endTimeStamp}
                            timeStep={this.state.timeStep}
                          />
                        )
                    )
                  )}
                </div>
              </>
            )}
          </OrdersSumQuery>
        )}
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orders/SumOrdered.tsx